<template>
  <v-autocomplete
    :loading="loading"
    :items="itemsauto"
    :search-input.sync="search"
    v-model="select"
    @click="
      select = null;
      search = '';
    "
    prepend-inner-icon="search"
    clear-icon="clear"
    item-text="v"
    item-value="k"
    flat
    light
    autofocus
    no-filter
    solo-inverted
    hide-details
    clearable
    :no-data-text="
      T('Digite para buscar módulos e pressione ENTER para pesquisar')
    "
    :label="T('Pesquisar')"
    @keydown.native.enter="forceQuery()"
  >
    <template slot="item" slot-scope="{ item, tile }">
      <v-list-tile-content v-if="item.t == 'module'">
        <v-list-tile-title v-text="item.v"></v-list-tile-title>
        <v-list-tile-sub-title v-text="item.d"></v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-content v-if="item.t == 'query'">
        <v-list-tile-title>
          {{ item.modt }}:
          <b>{{ item.v }}</b>
        </v-list-tile-title>
        <v-list-tile-sub-title v-text="item.d"></v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-content v-if="item.t == 'extra'">
        <v-list-tile-title>
          {{ item.modt }}:
          <b>{{ item.v }}</b>
        </v-list-tile-title>
        <v-list-tile-sub-title v-text="item.d"></v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-icon>navigate_next</v-icon>
      </v-list-tile-action>
    </template>
  </v-autocomplete>
</template>

<script>
const Api = global.Api;

export default {
  data: () => ({
    loading: false,
    search: null,
    select: "",
    itemsauto: [],
    debounce: null,
    querymodules: null,
    queryicons: {},
  }),
  props: ["menudata"],
  mounted() {},
  methods: {
    getQueryModules() {
      if (this.querymodules != null) return this.querymodules;

      console.log(this.menudata.items);
      let results = [];
      for (let secoes of this.menudata.items) {
        if (secoes.children != null) {
          for (let item of secoes.children) {
            results.push(item.url);
            this.queryicons[item.url] = item.icon;
          }
        } else {
          results.push(secoes.url);
          this.queryicons[secoes.url] = secoes.icon;
        }
      }
      this.querymodules = results;
      return this.querymodules;
    },
    buscaModulos(query) {
      let v = query.toLowerCase();

      let results = [];
      if (v == "") return [];

      for (let secoes of this.menudata.items) {
        if (secoes.children != null) {
          for (let item of secoes.children) {
            let desc = "";
            try {
              desc = global.config.metadmin.resumo[item.url] || "";
            } catch (err) {}

            if (item.text.toLowerCase().indexOf(v) !== -1) {
              results.push({
                k: "module-" + item.url,
                v: item.text,
                t: "module",
                i: item.icon,
                d: desc,
                s: -1,
              });
            }
          }
        } else {
          let desc = "";
          try {
            desc = global.config.metadmin.resumo[secoes.url] || "";
          } catch (err) {}
          if (secoes.text.toLowerCase().indexOf(v) !== -1) {
            results.push({
              k: "module-" + secoes.url,
              v: secoes.text,
              t: "module",
              i: secoes.icon,
              d: desc,
              s: -1,
            });
          }
        }
      }

      return results;
    },

    forceQuery() {
      this.querySelections(this.search, "server");
    },

    orderAndCrop() {
      this.itemsauto.sort((a, b) => {
        if (a.s < b.s) return -1;
        if (a.s > b.s) return 1;

        if (a.v < b.v) return -1;
        if (a.v > b.v) return 1;

        return 0;
      });
      this.itemsauto = this.itemsauto.slice(0, 10);
    },

    querySelections(v, modo) {
      this.loading = true;
      if (this.debounce != null) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }

      if (modo == "server") {
        if (v.length < 4) {
          this.loading = false;
          alert("Mínimo de 4 caracteres para pesquisar!");
          return;
        }

        let fazdepois = async () => {
          let credentials = {
            query: v,
            querymodules: this.getQueryModules(),
          };

          try {
            let result = await Api().post("admin/search/query", credentials);

            this.itemsauto = [];
            //let onsys = this.buscaModulos(v);

            if (result.data.output != null) {
              this.itemsauto = result.data.output.map((v) => {
                if (v.i == null) v.i = this.queryicons[v.k.split("-")[1]];
                return v;
              });
            }

            this.orderAndCrop();
            /*
            if (onsys.length > 0) {
              this.itemsauto = _.concat(this.itemsauto, onsys);
            }*/
          } catch (error) {
            alert(
              "error: " + error.message + "\n\n" + error.response.data.error
            );
          }

          this.loading = false;
          this.debounce = null;
        };
        this.debounce = setTimeout(fazdepois, 300);
      } else if (modo == "lite") {
        let fazdepois = async () => {
          let credentials = {
            query: v,
            querymodules: this.getQueryModules(),
          };

          this.itemsauto = [];

          let onsys = this.buscaModulos(v);
          if (onsys.length > 0) {
            this.itemsauto = onsys;
          }

          this.orderAndCrop();

          this.loading = false;
          this.debounce = null;
        };
        this.debounce = setTimeout(fazdepois, 50);
      }
    },
  },
  watch: {
    search(val) {
      if (val == "") {
        this.itemsauto = [];
        return;
      }
      val && val !== this.select && this.querySelections(val, "lite");
    },

    select(val) {
      //FAZ A ACAO

      if (val != null && val != "") {
        let element = _.find(this.itemsauto, { k: val });

        if (element.t == "module")
          this.$router.push({ path: `/admin/app/${val.substr(7)}` });
        if (element.t == "query")
          this.$router.push({
            path: element.l
              ? element.l
              : `/admin/app/${val.split("-")[1]}/open/view/${
                  val.split("-")[2]
                }`,
          });
        if (element.t == "extra")
          this.$router.push({
            path: element.l ? element.l : `/admin`,
          });
      }

      this.itemsauto = [];
    },
  },
};
</script>

<style scoped></style>
